import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import i18n from 'i18next';

import { showSnackbar } from '@/components/Toast';
import { emitTelemetry, normalizeError } from '@/observability';

declare module '@tanstack/react-query' {
  interface Register {
    mutationMeta: { errorMessage?: string };
    queryMeta: { errorMessage?: string };
  }
}

function operationName(key: readonly unknown[] | undefined): string {
  return typeof key?.[0] === 'string' ? key[0] : 'unknown';
}

export const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: (error, _variables, _context, mutation) => {
      emitTelemetry('frontend.mutation.error', {
        operation: operationName(mutation.options.mutationKey),
        ...normalizeError(error),
      });
      if (mutation.meta?.errorMessage) showSnackbar(i18n.t(mutation.meta.errorMessage));
    },
  }),
  queryCache: new QueryCache({
    onError: (error, query) => {
      emitTelemetry('frontend.query.error', {
        operation: operationName(query.queryKey),
        ...normalizeError(error),
      });
      if (query.meta?.errorMessage) showSnackbar(i18n.t(query.meta.errorMessage));
    },
  }),
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: 1000 * 60 * 5, // 5 minutes
    },
  },
});
